import { getQuickTopupOffer } from "@/lib/boide-api";
import { fromBootstrap } from "@/lib/bootstrap";
import { stampQuickTopupOffer, type QuickTopupOffer } from "@/lib/quick-topup";

/**
 * MỘT khóa cho offer Quick Topup — dùng chung giữa `__root` (pill countdown) và
 * trang chủ. Trước đây `__root` gọi thẳng API còn trang chủ đi qua react-query, nên
 * mỗi lượt vào web bắn HAI request `/quick-topup/offers` cùng lúc.
 */
export const QUICK_TOPUP_OFFER_QUERY_KEY = ["quick-topup-offer"] as const;

export const QUICK_TOPUP_OFFER_STALE_TIME = 30 * 1000;

/** React Query v5 không cho trả `undefined` — dùng `null` khi user chưa có offer. */
export async function fetchStampedQuickTopupOffer(): Promise<QuickTopupOffer | null> {
  const offer = await fromBootstrap("quick_topup_offer", getQuickTopupOffer);
  return stampQuickTopupOffer(offer ?? undefined) ?? null;
}
